import Vue from 'vue'
import {handleErrors} from "@/services/ErrorHandling";

const self = Vue.prototype

export default {

  getAll: () => {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.productTypes)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getFiltered(query, page = 1, perPage = 10) {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.productType + `?page=${page}&per_page=${perPage}&${query}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          handleErrors(error, reject)
        })
    })
  },

}